import {Injectable} from '@angular/core';

@Injectable()

export class GoogleMapsService {


  getaAdressData(autocomplete) {
    const tmpPlace = autocomplete.getPlace();
    const place = this.getAddressComponents(tmpPlace.address_components);
    return {
      autocomplete: tmpPlace.formatted_address,
      address: this.addressCompile(place),
      city: place.locality.long ? place.locality.long : place.postal_town.long, zip: place.postal_code.long,
      country: place.country.long,
      country_code: place.country.short,
    };
  }

  private addressCompile(place) {
    if (place.route.short) {
      if (place.street_number.short) {
        return place.route.short + ', ' + place.street_number.short;
      } else {
        return place.route.short;
      }
    } else {
      return '';
    }
  }

  private getAddressComponents(place: Array<any>) {
    const componentForm = {
      street_number: { 'long': '', 'short': '' },
      route: { 'long': '', 'short': '' },
      locality: { 'long': '', 'short': '' },
      postal_town: { 'long': '', 'short': '' },
      administrative_area_level_1: { 'long': '', 'short': '' },
      country: { 'long': '', 'short': '' },
      postal_code: { 'long': '', 'short': '' }
    };
    // Get each component of the address from the place details
    // and fill the corresponding field on the form.
    for (let i = 0; i < place.length; i++) {
      const addressType = place[i].types[0];
      if (componentForm[addressType]) {
        componentForm[addressType]['long'] = place[i]['long_name'];
        componentForm[addressType]['short'] = place[i]['short_name'];
      }
    }
    return componentForm;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/google-maps.service.ts